import { render, staticRenderFns } from "./searchquesstioninformation.vue?vue&type=template&id=2a929564"
import script from "./searchquesstioninformation.vue?vue&type=script&lang=js"
export * from "./searchquesstioninformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports